import { Button } from '../SideBar/Menu.style'
import {
  Container,
  ContainerTitleInativaOrganizacao,
  Modal,
  Buttons,
} from './style'

type DesativarProps = {
  texto: string
  botaoNao: () => void
  botaoSim: () => void
}

export function Desativar({ botaoNao, texto, botaoSim }: DesativarProps) {
  return (
    <Container>
      <Modal>
        <ContainerTitleInativaOrganizacao>
          {texto}
        </ContainerTitleInativaOrganizacao>
        <Buttons>
          <Button
            inativarOrganizacaoSim
            buttonType="SMALL"
            type="button"
            onClick={() => {
              botaoNao()
              botaoSim()
            }}
          >
            Sim
          </Button>
          <Button
            inativarOrganizacaoNao
            buttonType="SMALL"
            type="button"
            onClick={() => {
              botaoNao()
            }}
          >
            Não
          </Button>
        </Buttons>
      </Modal>
    </Container>
  )
}
